module.exports = __webpack_public_path__ + "static/media/clean_status_ok.dec3fb7e.svg";